var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":_vm.iconColor(_vm.value)}},[_vm._v(_vm._s(_vm.iconSimbol(_vm.value)))])}
var staticRenderFns = []

export { render, staticRenderFns }